import React from 'react';
import { useAuth } from '../context/AuthContext';

const RefreshToken = () => {
  const { user, updateUser } = useAuth();

  const refreshToken = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch('https://trcsite.net/api/auth/refresh-token', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        localStorage.setItem('token', data.token);
        if (updateUser) {
          updateUser(data.user);
        }
        console.log('✅ Token refreshed successfully:', data.user);
        alert('Token refreshed! You can now access admin features.');
        window.location.href = '/admin/chat';
      } else {
        const errorData = await response.json();
        console.error('Token refresh failed:', errorData);
        alert('Token refresh failed: ' + errorData.error);
      }
    } catch (error) {
      console.error('Token refresh error:', error);
      alert('Token refresh error: ' + error.message);
    }
  };

  return (
    <div style={{ 
      padding: '40px', 
      background: '#f8f9fa', 
      margin: '40px auto',
      borderRadius: '10px',
      maxWidth: '600px',
      textAlign: 'center'
    }}>
      <h2>🔄 Token Refresh Required</h2>
      <div style={{ background: 'white', padding: '20px', borderRadius: '8px', margin: '20px 0' }}>
        <p><strong>Current User:</strong> {user?.email} (ID: {user?.id})</p>
        <p><strong>Current Role:</strong> {user?.role || 'undefined'}</p>
        <p><strong>Issue:</strong> Your current token is missing user details needed for admin access.</p>
      </div>
      <button 
        onClick={refreshToken}
        style={{
          background: '#007bff',
          color: 'white',
          border: 'none',
          padding: '12px 24px',
          borderRadius: '6px',
          cursor: 'pointer',
          fontSize: '16px',
          fontWeight: 'bold'
        }}
      >
        Refresh Token & Continue to Admin Chat
      </button>
      <p style={{ fontSize: '14px', color: '#666', marginTop: '15px' }}>
        This will create a new token with complete user information.
      </p>
    </div>
  );
};

export default RefreshToken;